<template>
  <div
    :style="[styles.base, containerHeight,isShow]"
    @click="handleClickEvent()"
    @mouseenter="handleEvent('hover')"
  >
    <div
      data-id="start"
      :class="[getCss('point'),getCss(styles.line.startType+'-left'),getCss(styles.line.startType)]"
      :style="[startPoint]"
    />
    <div
      :class="[getCss('container'),]"
      :style="borderStyle"
    />

    <div
      data-id="end"
      :class="[getCss('point'),getCss(styles.line.endType+'-right'),getCss(styles.line.endType)]"
      :style="[endPoint]"
    />
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CLine',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'line-',
      classKeys: [
        'default',
      ],
    };
  },
  computed: {
    isShow() {
      const showObj = {};
      if (this.styles.base.display === 'none') {
        showObj.display = 'none';
      } else {
        showObj.display = 'flex';
      }
      return showObj;
    },
    // 获取线的样式
    borderStyle() {
      const { line: { width, style, color, startType, endType } } = this.styles;
      const borderObj = {
        borderTop: `${width}px ${style} ${color}`,
        flex: 1,
      };
      if (startType.includes('arrow')) {
        Object.assign(borderObj, { marginLeft: `${width}px` });
      }
      if (endType.includes('arrow')) {
        Object.assign(borderObj, { marginRight: `${width}px` });
      }
      return borderObj;
    },
    // 开始端点样式
    startPoint() {
      const { line: { startType, width, color  } } = this.styles;
      const pointStyleObj = this.getPointStyle(startType, width, color);
      return {
        ...pointStyleObj.default,
        ...pointStyleObj.startPoint,
      };
    },
    // 结束端点样式
    endPoint() {
      const { line: { endType, width, color  } } = this.styles;
      const pointStyleObj = this.getPointStyle(endType, width, color);
      return {
        ...pointStyleObj.default,
        ...pointStyleObj.endPoint,
      };
    },
    // 容器样式
    containerHeight() {
      const { line: { width, startType, endType } } = this.styles;
      // 优化线的宽度为1px时，不容易选中复制位置
      const minHeight = width < 4 ? 4 : width;
      const height = (startType === endType) && (startType === 'none') ? `${minHeight}px` : `${4 * width}px`;
      return {
        height,
        boxSizing: 'border-box',
        alignItems: 'center',
        justifyontent: 'space-between',
        overflow: 'hidden',
      };
    },
  },
  methods: {
    // 获取端点的样式
    getPointStyle(type, width, color) {
      switch (type) {
        case 'arrow-hollow':
          return {
            default: {
              width: `${4 * width}px`,
              height: `${4 * width}px`,
              borderTopColor: color,
              borderTopWidth: `${width}px`,
              borderRightWidth: `${width}px`,
              borderRightColor: color,
              position: 'absolute',
            },
            startPoint: {
              left: `${width}px`,
            },
            endPoint: {
              right: `${width}px`,
            },
          };
          break;
        case 'circle-default':
        case 'rectangle-default':
          return {
            default: {
              border: `${2 * width}px solid ${color}`,
              width: `${2 * width}px`,
              height: `${2 * width}px`,
            },
          };
          break;
        case 'arrow-default':
          return {
            default: {
              borderWidth: `${2 * width}px`,
              width: `${width}px`,
              position: 'absolute',
            },
            startPoint: {
              borderRightColor: color,
              left: `${-2 * width}px`,
            },
            endPoint: {
              borderLeftColor: color,
              right: `${-2 * width}px`,
            },
          };
          break;
        case 'circle-hollow':
          return {
            default: {
              border: `${width}px solid ${color}`,
              width: `${4 * width}px`,
              height: `${4 * width}px`,
            },
          };
          break;
        case 'rectangle-hollow':
          return {
            default: {
              border: `${width}px solid ${color}`,
              width: `${4 * width}px`,
              height: `${4 * width}px`,
            },
          };
          break;
        default:return {};
      }
    },
  },
};
</script>
<style lang="scss">
  @import './line.scss';
</style>
